export const ROWS_PER_PAGE = 100 // eslint-disable-line import/prefer-default-export
